import type { AppUser } from '@/domain/user'
import type { UserRepository } from '@/repositories/UserRepository'
import { seedUsers } from '@/data/seed/users'

export class LocalUserRepository implements UserRepository {
  async list(): Promise<AppUser[]> {
    return seedUsers
  }

  async getById(id: string): Promise<AppUser | null> {
    return seedUsers.find((u) => u.id === id) ?? null
  }

  async listByOrg(orgId: string): Promise<AppUser[]> {
    return seedUsers.filter((u) => u.orgId === orgId)
  }
}
